<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">View Event</p>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <router-link
              :to="{ name: 'photogallaryList' }"
              class="button is-info is-small btnicon"
              title="Back To List"
            >
              Back To List
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="container section is-main-section">
      <form>
        <div>
          <div class="columns row">
            <div class="column is-3">
              <div class="field">
                <label class="label"> from </label>
                <div class="control">
                  <input
                    disabled
                    class="input"
                    v-model="fromuser"
                    required
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">From </label>
              <div class="control">
                <input
                  class="input"
                  disabled
                  type="date"
                  v-model="fromDate"
                  required
                />
              </div>
            </div>

            <div class="column is-3">
              <label class="label">To </label>
              <div class="control">
                <input
                  class="input"
                  disabled
                  type="date"
                  v-model="toDate"
                  required
                />
              </div>
            </div>
            <div class="column is-3">
              <div class="field">
                <label class="label"> Title </label>
                <div class="control">
                  <input
                    disabled
                    class="input"
                    v-model="title"
                    required
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns row" style="width: 100%">
            <div class="columns form-row" style="width: 100%">
              <div class="column is-12">
                <div class="field">
                  <label class="label"> Description </label>
                  <!-- <ckeditor read-only required v-model="discription" ref="ckeditorRef"></ckeditor> -->
                  <!-- <textarea class="input" rows="3" readonly v-model="discription" ref="ckeditorRef"></textarea> -->
                  <quill-editor
                    :disabled="true"
                    :options="options"
                    v-model="discription"
                    theme="snow"
                    ref="myQuillEditor"
                  >
                  </quill-editor>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <div class="field">
                <label class="label"> Created At </label>
                <div class="control">
                  <input
                    disabled
                    class="input"
                    v-model="createdAt"
                    required
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <span v-if="dropFile1.length > 0">
                <div class="tags" v-for="(file, i) in dropFile1" :key="i">
                  <div
                    v-if="file.type === 'VIDEO'"
                    @click="downloadVid(file.urlPath)"
                    class="tag is-primary"
                  >
                    {{ file.type }}
                  </div>
                  <div
                    v-if="file.type === 'IMAGE' && file.isLink === false"
                    @click="downloadImg(file.urlPath)"
                    class="tag is-primary"
                  >
                    {{ file.type }}
                  </div>
                  <div
                    v-if="file.type === 'IMAGE' && file.isLink === true"
                    @click="viewImg(file.urlPath)"
                    class="tag is-primary"
                  >
                    {{ file.type }}
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'

// import Utils from '@/utils'
import moment from 'moment'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'viewPhotogallary',
  props: ['photoGalleryID'],
  components: {
    quillEditor
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      discription: '',
      type: '',
      title: '',
      fromDate: '',
      toDate: '',
      typeData: [],
      annonceData: [],
      hasClicked: false,
      loader: true,
      sendData: {},
      selectedfranchiseeID: [],
      dropFile1: [],
      createdAt: '',
      fromuser: '',
      options: {
        debug: 'info',
        modules: {
          toolbar: []
        },
        readOnly: true,
        theme: 'snow'
      }
    }
  },

  async created () {
    await this.photoGallery()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) { that.instance.execCommand('maximize') }
    next()
  },
  methods: {
    photoGallery: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/photo-gallery/${this.photoGalleryID}`
        )
        this.annonceData = data
        this.title = this.annonceData.title
        this.discription = this.annonceData.descriptions
        this.fromDate = moment(this.annonceData.startDate, 'YYYY-MM-DD').format(
          'YYYY-MM-DD'
        )
        this.toDate = moment(this.annonceData.endDate, 'YYYY-MM-DD').format(
          'YYYY-MM-DD'
        )
        this.createdAt = moment(
          this.annonceData.createdAt,
          'YYYY-MM-DD'
        ).format('YYYY-MM-DD')
        this.fromuser = this.annonceData.user
          ? this.annonceData.user.firstName +
            '' +
            this.annonceData.user.lastName
          : this.annonceData.user.firstName
        this.dropFile1 = this.annonceData.photoGalleryDocumentMaps
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    downloadVid: async function (i) {
      window.open(i)
    },
    viewImg: async function (i) {
      window.open(i)
    },
    downloadImg: async function (i) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    }
  }
}
</script>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
